import { createSelector } from 'reselect';
import { isArray } from 'lodash';

/**
 * Selects the list of geofence locations from Redux state.
 * @param {object} state - Redux state
 * @returns {Array|null}
 */
export const geofenceLocationsSelector = (state) => state?.geofenceSettings?.geofenceLocations;

/**
 * Transforms raw geofence locations from Redux state into a normalized shape
 * suitable for use in meshbot trigger dropdowns.
 * Maps { locationUuid, locationName } → { uuid, name }.
 * @param {Array<{ locationUuid: string, locationName: string }>|null} locations
 * @returns {Array<{ uuid: string, name: string }>}
 */
const transformGeofenceLocations = (locations) => {
    if (!isArray(locations)) {
        return [];
    }

    return locations.map(({ locationUuid, locationName }) => ({
        uuid: locationUuid,
        name: locationName,
    }));
};

/**
 * Memoized selector that returns geofence locations normalized for meshbot trigger dropdowns.
 * @param {object} state - Redux state
 * @returns {Array<{ uuid: string, name: string }>}
 */
export const geofencesSelector = createSelector([geofenceLocationsSelector], transformGeofenceLocations);

/**
 * Selects the list of registered geofence devices from Redux state.
 * @param {object} state - Redux state
 * @returns {Array|null}
 */
export const geofenceRegisteredDevicesSelector = (state) => state?.geofenceSettings?.geofenceRegisteredDevices;

/**
 * Selects the usedInMeshbots object from Redux state.
 * @param {object} state - Redux state
 * @returns {{ isLoading: boolean, error: string|null, hasOfflineControllers: boolean, locations: { cloud: string[], local: string[] } }|undefined}
 */
export const usedInMeshbotsSelector = (state) => state?.geofenceSettings?.usedInMeshbots;
